<button color="primary" type="button" aria-label="Back to top of page" class="back-to-top-button"
  [@appearInOut]="animationState" (click)="scrollTop($event)">
  <fa-icon [icon]="faArrowUp"></fa-icon>
</button>
